import { render } from "./trustedIconAlt.vue?vue&type=template&id=462fc32b&scoped=true"
import script from "./trustedIconAlt.vue?vue&type=script&lang=js"
export * from "./trustedIconAlt.vue?vue&type=script&lang=js"

import "./trustedIconAlt.vue?vue&type=style&index=0&id=462fc32b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-462fc32b"],['__file',"webpack-assets/vue/components/trustedIconAlt.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "462fc32b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('462fc32b', __exports__)) {
    api.reload('462fc32b', __exports__)
  }
  
  module.hot.accept("./trustedIconAlt.vue?vue&type=template&id=462fc32b&scoped=true", () => {
    api.rerender('462fc32b', render)
  })

}


export default __exports__